export enum MfaBypassTokenDuration {
  "1 minute" = 0,
  "1 hour" = 1,
  "6 hours" = 2,
  "1 day" = 3,
  "3 days" = 4,
  "1 week" = 5,
  "2 weeks" = 6,
  "1 month" = 7,
}
